
angular.module('app.controllers.nav', [])
  .controller('NavController', ['$rootScope', '$scope', '$timeout', '$window', '$log', 'MobileMenu', 'SessionService', 'SquizSearchService',
    function ($rootScope, $scope, $timeout, $window, $log, MobileMenu, SessionService, SquizSearchService) {

      'use strict';

      $log.debug('NavController()');

      $scope.alertVisible = false;
      $scope.userKnown = true;
      $scope.suggestionsData = {};
	  $scope.suggestionsOptions = { 'sort': 0, 'show': 3 };
	  $scope.data = {};
	  $scope.spellingSuggestionOptions = { 'max': 10 };
	  $scope.suggestionsVisible = false;
	  $scope.searchQuery = '';
	  
	  var params = window.location.search.slice(1).split('&');
	  var result = {};
	 	
	  params.forEach(function(pair) {
		  pair = pair.split('=');
		  var val = decodeURIComponent(pair[1] || '');
		  if (val !== '' && !isNaN(Number(val))) {
	 		val = parseInt(val);
		  }
		  result[pair[0]] = val;
	  });
	  $scope.searchQuery = result.query;
	  if($scope.searchQuery) {
		  $scope.searchQuery = $scope.searchQuery.replace(/\+/g, '%20');
		  $scope.searchQuery = decodeURIComponent($scope.searchQuery);
	  }

      $scope.menu = {};

      $scope.toggleMenu = function($event,menu) {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.menu[menu] = !$scope.menu[menu];
      };

      $scope.setUserLocation = function (state, location) {
        var previousState = $rootScope.userState;
        if (previousState != state) {
          SessionService.setCurrentLocation(state.toUpperCase());
          var path = window.location.pathname;
          var index = path.indexOf('/' + previousState + '-');
          if (index>0) {
            path = path.substring(0,index) + '/' + state + '-' + path.substring(index + 4);
            window.location = path;
          }
        }
      };

      // push down menu for alerts
      $rootScope.$on('push_down_menu', function (evt, val) {
        $log.debug('> receiving broadcast push_down_menu:', val);
        $scope.alertVisible = val.open;
      });

      $scope.stateActive = function (state) {
        return ($rootScope.userState === state) ? 'selected-state' : '';
      };

      // initialize menu
      MobileMenu.init();

      $scope.toggleNav = function () {
        MobileMenu.toggle();
      };
      
      $scope.getSuggestions = function() {
 		if($scope.searchQuery.length >= 3) {
 			$scope.suggestionsVisible = true;
 			$scope.suggestionsOptions.partial_query = $scope.searchQuery;
 			
 			$scope.spellingSuggestionOptions.query = $scope.searchQuery;
 			SquizSearchService.findPages($scope.spellingSuggestionOptions, $scope.data);
 			
 			$scope.suggestionsOptions.collection = 'swgas~sp-meta';
	 		SquizSearchService.findSuggestions($scope.suggestionsOptions, $scope.suggestionsData);
 		} else {
 			$scope.suggestionsVisible = false;
 		}
      };
      
      $scope.closeSuggestions = function() {
    	  $scope.suggestionsVisible = false;
      };

      $timeout(function() {
        var path = $window.location.pathname;
        var dash = path.indexOf('-');
        if (dash > 0) {
          // Expecting URLs like /(en|es)/(az-|ca-|nv-)
          var temp = path.substring(0, dash);
          var elements = temp.split("/");
          if (elements.length === 3) {
            var state = elements[2];
            switch(state) {
              case 'az':
              case 'ca':
              case 'nv':
                SessionService.setCurrentLocation(state.toUpperCase());
                break;
            }
          }
        }
      });
    }])
  .controller('OvalNavController', function($scope) {
    $scope.getLinkClasses = function (link) {
      return (link === window.location.pathname) ? 'inline-block oval-menu-label' : 'small-bold-link';
    };
  });